import { RulesetRulePath } from "@shared/types";

import { authGet } from "../auth";

export function fetchRulesetRulePaths(): Promise<RulesetRulePath[]> {
  return authGet<RulesetRulePath[]>(`/api/registry/ruleset_rule_paths`);
}
